import { NgStyle } from '@angular/common';
import { Component, computed, input } from '@angular/core';

@Component({
  selector: 'wk8-claw-front',
  imports: [NgStyle],
  templateUrl: './wk8-claw-front.component.html',
  styleUrls: ['./wk8-claw-front.component.css'],
})
export class Wk8ClawFrontComponent {
  readonly spritePath = 'assets/woordkr8/sprites/';
  opened = input(false);
  lightColor = input<'blue' | 'orange' | 'green' | 'none'>('orange');
  size = input(1);

  lightAssetPath = computed(() => {
    switch (this.lightColor()) {
      case 'blue':
        return this.spritePath + 'blue-light.png';
      case 'orange':
        return this.spritePath + 'orange-light.png';
      case 'green':
        return this.spritePath + 'green-light.png';
      case 'none':
        return this.spritePath + 'no-light.png';
    }
  });
}
